<template>
    <div>
        <div class="right">
          <v-btn @click="getDateTotal()" color="" class="mr-0">reveal&nbsp;<b>{{currentMonthYear}}</b></v-btn>
        </div>
        <div class="left">
          <Fullcalendar
            :plugins="calendarPlugins"
            :header="{
              left:'prev',
              center:' title ',
              right:'next'
            }"
            :selectable= "true"
            :events= "fcEvents"
            :showNonCurrentDates= "false"
            eventColor= '#339900'
            :displayEventTime= "false"
            :theme= "true"
            @eventClick= "handleClick"
            @datesRender= "handleMonthChange"
            />
            <modals-container />
        </div>
    </div>
</template>

<script>
import OrderService from '@/services/OrderService'
import Fullcalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import listPlugin from '@fullcalendar/list'
import AgendaModal from './AgendaModal'
import moment from 'moment'

require('@fullcalendar/core/main.min.css')
require('@fullcalendar/daygrid/main.min.css')
require('@fullcalendar/timegrid/main.min.css')

export default {
  data: () => ({
    calendarPlugins: [
      dayGridPlugin,
      timeGridPlugin,
      interactionPlugin,
      listPlugin
    ],
    fcEvents: [],
    currentMonth: moment().format('M'),
    currentYear: moment().format('Y'),
    currentMonthYear: moment().format('MMMM YYYY'),
    MonthsYearsDone: [],
    loggedInUser: JSON.parse(atob(localStorage.getItem('user')))
  }),
  mounted () {
    // this.getDateTotal()
  },
  methods: {
    async getDateTotal () {
      /* var today = new Date()
      var currentMonth = today.getMonth() + 1
      var year = today.getFullYear()
      for (let m = currentMonth; m > 0; m--) {
        for (let index = 1; index <= this.lastdate(year, m); index++) {
          let day = index
          let month = m
          // console.log(day.toString().length)
          day = day.toString().length === 1 ? `0${day}` : day
          month = month.toString().length === 1 ? `0${month}` : month
          // let startdate = new Date(`${year}-${month}-${day} 00:00:00`).toUTCString()
          // let enddate = new Date(`${year}-${month}-${day} 00:00:02`).toUTCString()
          let date = `${year}-${month}-${day}T00:00:00+00:00`
          let dateResponse = await OrderService.getDateWiseTotal(year, month, day)
          let total = dateResponse.data.todayTotal
          let orders = dateResponse.data.orders
          this.fcEvents.push({ title: '$' + total.toFixed(2), start: date, end: date, orders: orders })
          // console.log(date)
          // console.log(startdate)
          // console.log(enddate)
        }
      } */
      var currentMonth = this.currentMonth
      var year = this.currentYear
      if (this.MonthsYearsDone.includes(currentMonth + year)) {
        return
      }
      this.MonthsYearsDone.push(currentMonth + year)
      for (let index = 1; index <= this.lastdate(year, currentMonth); index++) {
        let day = index
        let month = currentMonth
        // console.log(day.toString().length)
        day = day.toString().length === 1 ? `0${day}` : day
        month = month.toString().length === 1 ? `0${month}` : month
        // let startdate = new Date(`${year}-${month}-${day} 00:00:00`).toUTCString()
        // let enddate = new Date(`${year}-${month}-${day} 00:00:02`).toUTCString()
        let date = `${year}-${month}-${day}T00:00:00+00:00`
        let dateResponse = await OrderService.getDateWiseTotal(year, month, day)
        let total = dateResponse.data.todayTotal
        let orders = dateResponse.data.orders
        this.fcEvents.push({ title: '$' + total.toFixed(2), start: date, end: date, orders: orders })
        // console.log(date)
        // console.log(startdate)
        // console.log(enddate)
      }
    },
    lastdate (y, m) {
      return new Date(y, m, 0).getDate()
    },
    handleClick (arg) {
      // alert(arg.event.extendedProps.orders)
      this.$modal.show(AgendaModal, {orders: arg.event.extendedProps.orders}, {width: '800', height: '400'})
      // console.log(arg)
    },
    handleSelect (arg) {
      console.log(arg)
    },
    handleLoad (arg) {
      console.log(arg)
      console.log('arg')
    },
    handleMonthChange (arg) {
      var currentStart = arg.view.currentStart
      var check = moment(currentStart, 'YYYY/MM/DD')
      this.currentMonth = check.format('M')
      this.currentYear = check.format('Y')

      this.currentMonthYear = moment(currentStart).format('MMMM YYYY')
    }
  },
  components: {
    Fullcalendar
  }
}
// $('#calendar_1').fullCalendar({
//   header: {
//       left: '',
//       center: 'title',
//       right: ''
//   },
//   defaultView: 'month',
//   editable: true,
//   allDaySlot: true,
//   selectable: true,
//   selectHelper: true,
//   selectOverlap: false,
//   fixedWeekCount: false,
//   showNonCurrentDates: false,
//   select: function (start, end) {
//       var title = "Available";
//       var evid = SaveEvent(start, end, '1');
//       $('#calendar_1').fullCalendar('unselect');
//   },
//   eventClick: function (calEvent, jsEvent, view) {
//       var ev_id = calEvent.ID;
//       var st_dt = calEvent.start;
//       var ed_dt = calEvent.end;
//       infoEventShow('1', ev_id, st_dt, ed_dt);
//   },
//   slotMinutes: 15,
//   events: '/Aircrew/GetEvents/',
//   eventColor: '#339900'
// });
</script>

<style>
.fc-content {
    font-size: 16px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Agenda.vue